import { render } from "./recipients.vue?vue&type=template&id=0cb9baa6"
import script from "./recipients.vue?vue&type=script&lang=js"
export * from "./recipients.vue?vue&type=script&lang=js"

import "./recipients.vue?vue&type=style&index=0&id=0cb9baa6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__